module.exports = __webpack_public_path__ + "img/b2.aeb7820.jpg";